import React from 'react';
import { TgAuth } from './tg-auth.view';
import { TgAuthProvider } from './tg-auth.provider';

type TgAuthFeatureProps = {
   captchaKey: string | null;
};

export const TgAuthFeature: React.FC<TgAuthFeatureProps> = () => {
   return (
      <TgAuthProvider>
         <TgAuth />
      </TgAuthProvider>
   );
};
